var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTongyongQuxiaotixing(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.5 14a1.5 1.5 0 003 0h-1a.5.5 0 01-1 0h-1z",
    fill: "#3F465C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.722 1.723L1.39 13.056",
    stroke: "#3F465C",
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.06 13.5H14a.5.5 0 000-1H4.06l-1 1zm-.414-1H2a.5.5 0 00-.273.919l.919-.919z",
    fill: "#3F465C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.063 13.5H13v-6c0-1.11-.361-2.135-.973-2.964l-.717.717c.435.64.69 1.414.69 2.247v5H4.063l-1 1zm7.584-8.999A4 4 0 004 7.5v3.649l-1 1V7.5a5 5 0 018.356-3.707l-.709.708z",
    fill: "#3F465C"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8 2.735V2",
    stroke: "#3F465C",
    strokeLinecap: "round"
  })));
}
export default __webpack_public_path__ + "static/tongyong_quxiaotixing.bb6aa759.svg";
export { SvgTongyongQuxiaotixing as ReactComponent };